"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1801],{

/***/ 28624:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Support; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/hooks/useTranslation.tsx + 1 modules
var useTranslation = __webpack_require__(85683);
// EXTERNAL MODULE: ./src/utils/url.utils.ts
var url_utils = __webpack_require__(8333);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(96502);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 7 modules
var styled_components_browser_esm = __webpack_require__(50661);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
;// CONCATENATED MODULE: ./src/components/CartSupport/Support.elements.tsx



var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Supportelements__Wrapper",
  componentId: "sc-7gaa89-0"
})(["border:1px solid ", ";border-radius:", ";padding:", ";margin-top:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.border;
}, (0,polished_esm/* rem */.hO)(8), (0,polished_esm/* rem */.hO)(25), function (props) {
  return props.withoutMargin ? 0 : (0,polished_esm/* rem */.hO)(60);
});
var Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Supportelements__Content",
  componentId: "sc-7gaa89-1"
})(["display:flex;"]);
var Image = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
  displayName: "Supportelements__Image",
  componentId: "sc-7gaa89-2"
})(["min-width:", ";height:", ";border-radius:50%;min-height:", ";height:", ";@media (min-width:", "px){min-height:", ";min-width:", ";}"], (0,polished_esm/* rem */.hO)(80), (0,polished_esm/* rem */.hO)(80), (0,polished_esm/* rem */.hO)(80), (0,polished_esm/* rem */.hO)(80), theme/* breakpoints.xs */.A.xs, (0,polished_esm/* rem */.hO)(105), (0,polished_esm/* rem */.hO)(105));
var Details = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Supportelements__Details",
  componentId: "sc-7gaa89-3"
})(["display:flex;flex-direction:column;padding-left:", ";position:relative;width:100%;@media (min-width:", "px){justify-content:center;}"], (0,polished_esm/* rem */.hO)(25), theme/* breakpoints.sm */.A.sm);
var Question = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Supportelements__Question",
  componentId: "sc-7gaa89-4"
})(["font-size:", ";padding-bottom:", ";display:block;line-height:", ";font-weight:", ";"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontSizes.h5;
}, (0,polished_esm/* rem */.hO)(15), (0,polished_esm/* rem */.hO)(30), function (_ref3) {
  var theme = _ref3.theme;
  return theme.fontWeights.textBold;
});
var Label = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Supportelements__Label",
  componentId: "sc-7gaa89-5"
})(["padding-bottom:", ";line-height:", ";a{color:", ";font-weight:", ";}"], (0,polished_esm/* rem */.hO)(15), (0,polished_esm/* rem */.hO)(26), function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.primary;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.fontWeights.textBold;
});
var Phone = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Supportelements__Phone",
  componentId: "sc-7gaa89-6"
})(["a{font-weight:", ";color:", ";}"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.fontWeights.textBold;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.primary;
});
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/CartSupport/Support.tsx







var SupportTemplate = function SupportTemplate(_ref) {
  var withoutMargin = _ref.withoutMargin,
      withoutBackground = _ref.withoutBackground;

  var _useTranslations = (0,useTranslation/* default */.Z)(),
      t = _useTranslations.t;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Wrapper, {
    withoutMargin: withoutMargin,
    withoutBackground: withoutBackground,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Question, {
      children: t('cart.support.question')
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Content, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Image, {
        src: (0,url_utils/* publicAssets */.VK)('/team_person9_square.jpg')
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Details, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Label, {
          children: t('cart.support.description')
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Phone, {
          dangerouslySetInnerHTML: {
            __html: t('cart.support.phone')
          }
        })]
      })]
    })]
  });
};

/* harmony default export */ var Support = (SupportTemplate);

/***/ }),

/***/ 84634:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ TrainingDates; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/hooks/useCart.tsx + 1 modules
var useCart = __webpack_require__(44722);
// EXTERNAL MODULE: ./src/hooks/useTranslation.tsx + 1 modules
var useTranslation = __webpack_require__(85683);
// EXTERNAL MODULE: ./src/ui/Button/Button.tsx + 1 modules
var Button = __webpack_require__(83537);
// EXTERNAL MODULE: ./src/ui/Package/Package.tsx + 1 modules
var Package = __webpack_require__(42420);
// EXTERNAL MODULE: ./src/ui/Quantity/Quantity.tsx + 1 modules
var Quantity = __webpack_require__(43156);
// EXTERNAL MODULE: ./src/ui/Tag/Tag.tsx + 1 modules
var Tag = __webpack_require__(67279);
// EXTERNAL MODULE: ./src/utils/cart.utils.ts
var cart_utils = __webpack_require__(80018);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./src/constants/index.ts
var constants = __webpack_require__(40238);
// EXTERNAL MODULE: ./src/constants/packages.ts
var constants_packages = __webpack_require__(31828);
// EXTERNAL MODULE: ./src/interfaces/Calendar.ts
var Calendar = __webpack_require__(17923);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(96502);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 7 modules
var styled_components_browser_esm = __webpack_require__(50661);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
;// CONCATENATED MODULE: ./src/components/TrainingDates/TrainingDates.elements.tsx



var Table = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TrainingDateselements__Table",
  componentId: "sc-fngobc-0"
})(["margin:0 ", ";"], (0,polished_esm/* rem */.hO)(15));
var TableHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TrainingDateselements__TableHeader",
  componentId: "sc-fngobc-1"
})(["border-bottom:2px solid ", ";padding:", " 0;"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.secondaryGrey;
}, (0,polished_esm/* rem */.hO)(20));
var TableHeaderLabel = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "TrainingDateselements__TableHeaderLabel",
  componentId: "sc-fngobc-2"
})(["", ";", ";", ";font-size:", ";@media (min-width:", "px){display:inline-block;}"], function (prop) {
  return prop.width ? "width: ".concat(prop.width, "%;") : '';
}, function (prop) {
  return prop.center ? "text-align: center;" : '';
}, function (prop) {
  return prop.hideOnMobile ? "display: none;" : '';
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontSizes.textBase;
}, theme/* breakpoints.sm */.A.sm);
var TableItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TrainingDateselements__TableItem",
  componentId: "sc-fngobc-3"
})(["padding:", " 0;border-bottom:", ";@media (min-width:", "px){display:flex;align-items:center;padding:", " 0;}"], (0,polished_esm/* rem */.hO)(25), function (props) {
  return props.hasTags ? 'none' : "1px solid ".concat(props.theme.colors.secondaryGrey);
}, theme/* breakpoints.sm */.A.sm, (0,polished_esm/* rem */.hO)(25));
var Tags = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TrainingDateselements__Tags",
  componentId: "sc-fngobc-4"
})(["padding:", ";@media (min-width:", "px){padding:", " 0 ", " 0;}border-bottom:1px solid ", ";"], (0,polished_esm/* rem */.hO)(10), theme/* breakpoints.sm */.A.sm, (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(25), function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.secondaryGrey;
});
var ProductDetail = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TrainingDateselements__ProductDetail",
  componentId: "sc-fngobc-5"
})(["@media (min-width:", "px){width:30%;}"], theme/* breakpoints.sm */.A.sm);
var ProductName = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "TrainingDateselements__ProductName",
  componentId: "sc-fngobc-6"
})(["font-weight:", ";display:block;cursor:pointer;", ";", ";"], function (props) {
  return props.isBold ? props.theme.fontWeights.textBold : props.theme.fontWeights.textLight;
}, function (prop) {
  return prop.isBold ? "font-weight: ".concat(prop.theme.fontWeights.textBold) : '';
}, function (prop) {
  return prop.noWrap ? "white-space: nowrap" : '';
});
var Form = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "TrainingDateselements__Form",
  componentId: "sc-fngobc-7"
})(["display:inline-block;margin-top:", ";"], function (props) {
  return props.withMarginTop ? (0,polished_esm/* rem */.hO)(5) : 0;
});
var HasBoughtTag = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "TrainingDateselements__HasBoughtTag",
  componentId: "sc-fngobc-8"
})(["display:block;background:", ";color:", ";font-size:", ";padding:", " 0;font-weight:400;margin-bottom:", ";width:", ";text-transform:uppercase;text-align:center;border-radius:", ";"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.green;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.white;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.fontSizes.textSmall;
}, (0,polished_esm/* rem */.hO)(4), (0,polished_esm/* rem */.hO)(8), (0,polished_esm/* rem */.hO)(95), (0,polished_esm/* rem */.hO)(16));
var ProductDate = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "TrainingDateselements__ProductDate",
  componentId: "sc-fngobc-9"
})(["display:block;padding-top:", ";color:", ";"], (0,polished_esm/* rem */.hO)(5), function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.grey;
});
var ProductMap = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
  displayName: "TrainingDateselements__ProductMap",
  componentId: "sc-fngobc-10"
})(["color:", ";cursor:pointer;text-decoration:unset;"], function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.primary;
});
var ProductQuantity = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TrainingDateselements__ProductQuantity",
  componentId: "sc-fngobc-11"
})(["display:flex;justify-content:space-between;align-items:center;padding:", " 0 ", " 0;@media (min-width:", "px){width:20%;justify-content:center;margin-left:", ";padding:0;}"], (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(15), theme/* breakpoints.sm */.A.sm, (0,polished_esm/* rem */.hO)(5));
var ProductPrice = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TrainingDateselements__ProductPrice",
  componentId: "sc-fngobc-12"
})(["display:flex;justify-content:space-between;align-items:center;@media (min-width:", "px){width:20%;justify-content:center;height:", ";}"], theme/* breakpoints.sm */.A.sm, (0,polished_esm/* rem */.hO)(40));
var Buy = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TrainingDateselements__Buy",
  componentId: "sc-fngobc-13"
})(["display:flex;align-items:center;margin-right:0;padding:", " 0 0 0;cursor:pointer;margin-left:50%;@media (min-width:", "px){padding:0;width:20%;margin-left:5%;}"], (0,polished_esm/* rem */.hO)(25), theme/* breakpoints.sm */.A.sm);
var Label = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "TrainingDateselements__Label",
  componentId: "sc-fngobc-14"
})(["color:", ";@media (min-width:", "px){display:none;}"], function (_ref9) {
  var theme = _ref9.theme;
  return theme.colors.grey;
}, theme/* breakpoints.sm */.A.sm);
var ProductPackage = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "TrainingDateselements__ProductPackage",
  componentId: "sc-fngobc-15"
})(["display:inline-block;font-weight:", ";margin-bottom:", ";padding-left:", ";"], function (_ref10) {
  var theme = _ref10.theme;
  return theme.fontWeights.textBold;
}, (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(10));
var ProductPackageTitle = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "TrainingDateselements__ProductPackageTitle",
  componentId: "sc-fngobc-16"
})(["color:", ";display:block;", ";"], function (_ref11) {
  var theme = _ref11.theme;
  return theme.colors.grey;
}, function (prop) {
  return prop.minWidth ? "min-width: ".concat(prop.minWidth, "px;") : '';
});
var Value = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "TrainingDateselements__Value",
  componentId: "sc-fngobc-17"
})(["text-align:center;display:flex;align-items:center;font-weight:", ";", ";", ";"], function (_ref12) {
  var theme = _ref12.theme;
  return theme.fontWeights.textBold;
}, function (prop) {
  return prop.isPrice ? "font-size: ".concat(prop.theme.fontSizes.textMedium, ";") : '';
}, function (prop) {
  return prop.withHeight ? "height: ".concat((0,polished_esm/* rem */.hO)(40), ";") : '';
});
var Item = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TrainingDateselements__Item",
  componentId: "sc-fngobc-18"
})([""]);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/TrainingDates/TrainingDates.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



















var TrainingDatesTemplate = function TrainingDatesTemplate(_ref) {
  var trainingDates = _ref.dates,
      isCustom = _ref.isCustom,
      isAcademy = _ref.isAcademy,
      modules = _ref.modules;

  var _useTranslations = (0,useTranslation/* default */.Z)(),
      t = _useTranslations.t;

  var router = (0,next_router.useRouter)();

  var _useCart = (0,useCart/* default */.ZP)(),
      addOrUpdateItemInCart = _useCart.addOrUpdateItemInCart;

  var _useState = (0,react.useState)([]),
      dates = _useState[0],
      setDates = _useState[1];

  var _useState2 = (0,react.useState)({}),
      quantities = _useState2[0],
      setQuantities = _useState2[1];

  (0,react.useEffect)(function () {
    if ((trainingDates === null || trainingDates === void 0 ? void 0 : trainingDates.length) > 0) {
      setDates(trainingDates);
      trainingDates.map(function (trainingDate) {
        quantities[trainingDate.date._key] = 1;
        setQuantities(quantities);
      });
    }
  }, [trainingDates]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Table, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(TableHeader, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TableHeaderLabel, {
          width: 24,
          children: t('cart.header.term')
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(TableHeaderLabel, {
          width: 20,
          center: true,
          hideOnMobile: true,
          children: t('cart.header.count')
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(TableHeaderLabel, {
          width: 15,
          center: true,
          hideOnMobile: true,
          children: t('cart.header.priceWithoutVat')
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(TableHeaderLabel, {
          width: 18,
          center: true,
          hideOnMobile: true,
          children: t('cart.header.price')
        })]
      }), dates === null || dates === void 0 ? void 0 : dates.map(function (date, index) {
        var _date$tags, _date$venues, _date$venues$, _date$venues2, _date$venues2$, _date$venues3, _date$venues3$, _date$venues4, _date$venues4$, _date$venues4$$name, _date$venues5, _date$venues5$, _date$venues5$$street, _date$venues6, _date$venues6$, _date$venues6$$street, _date$venues7, _date$venues7$, _date$venues8, _date$venues8$, _date$venues9, _date$venues9$, _date$modules, _date$modules$, _date$modules2, _date$modules2$, _date$tags2, _date$tags2$filter, _date$tags3, _date$tags3$filter;

        var formattedDateFromWithDay = moment_default()(date.date.from).local().format('DD. MM. YYYY');
        var formattedDateToWithDay = moment_default()(date.date.to).local().format('DD. MM. YYYY');
        var isRealized = isAcademy ? moment_default()().local().diff(date.date.to, 'minutes') > 0 : moment_default()().local().diff(date.date.from, 'minutes') > 0;
        var isRunning = moment_default()().local().diff(date.date.from, 'minutes') > 0 && moment_default()().local().diff(date.date.to, 'minutes') < 0;
        return /*#__PURE__*/(0,jsx_runtime.jsxs)(Item, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(TableItem, {
            isCheckout: true,
            isSummary: true,
            hasTags: (date === null || date === void 0 ? void 0 : (_date$tags = date.tags) === null || _date$tags === void 0 ? void 0 : _date$tags.length) > 0,
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(ProductDetail, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(ProductName, {
                isBold: true,
                children: [date.accessible && /*#__PURE__*/(0,jsx_runtime.jsx)(HasBoughtTag, {
                  children: t('training.hasBought')
                }), formattedDateFromWithDay, date.date.to && formattedDateFromWithDay !== formattedDateToWithDay ? " - ".concat(formattedDateToWithDay) : '', ' ', !isAcademy && "(".concat(moment_default()(date.date.from).local().format('HH:mm'), " - ").concat(moment_default()(date.date.to).local().format('HH:mm'), ")"), ' ', !isAcademy && '|', ' ', /*#__PURE__*/(0,jsx_runtime.jsxs)(Form, {
                  withMarginTop: isAcademy,
                  children: [date.isOnline ? t('event.isOnline') : ((_date$venues = date.venues) === null || _date$venues === void 0 ? void 0 : (_date$venues$ = _date$venues[0]) === null || _date$venues$ === void 0 ? void 0 : _date$venues$.city) || ((_date$venues2 = date.venues) === null || _date$venues2 === void 0 ? void 0 : (_date$venues2$ = _date$venues2[0]) === null || _date$venues2$ === void 0 ? void 0 : _date$venues2$.name), date.isPresence ? "".concat(date.isOnline ? ' | ' : '').concat(t('event.isPresent')) : '']
                })]
              }), ((_date$venues3 = date.venues) === null || _date$venues3 === void 0 ? void 0 : (_date$venues3$ = _date$venues3[0]) === null || _date$venues3$ === void 0 ? void 0 : _date$venues3$.city) && /*#__PURE__*/(0,jsx_runtime.jsxs)(ProductDate, {
                children: [(_date$venues4 = date.venues) === null || _date$venues4 === void 0 ? void 0 : (_date$venues4$ = _date$venues4[0]) === null || _date$venues4$ === void 0 ? void 0 : (_date$venues4$$name = _date$venues4$.name) === null || _date$venues4$$name === void 0 ? void 0 : _date$venues4$$name.replace("".concat((_date$venues5 = date.venues) === null || _date$venues5 === void 0 ? void 0 : (_date$venues5$ = _date$venues5[0]) === null || _date$venues5$ === void 0 ? void 0 : (_date$venues5$$street = _date$venues5$.street) === null || _date$venues5$$street === void 0 ? void 0 : _date$venues5$$street.trim(), ","), ''), ((_date$venues6 = date.venues) === null || _date$venues6 === void 0 ? void 0 : (_date$venues6$ = _date$venues6[0]) === null || _date$venues6$ === void 0 ? void 0 : (_date$venues6$$street = _date$venues6$.street) === null || _date$venues6$$street === void 0 ? void 0 : _date$venues6$$street.trim()) && ", ".concat((_date$venues7 = date.venues) === null || _date$venues7 === void 0 ? void 0 : (_date$venues7$ = _date$venues7[0]) === null || _date$venues7$ === void 0 ? void 0 : _date$venues7$.street), ((_date$venues8 = date.venues) === null || _date$venues8 === void 0 ? void 0 : (_date$venues8$ = _date$venues8[0]) === null || _date$venues8$ === void 0 ? void 0 : _date$venues8$.link) && /*#__PURE__*/(0,jsx_runtime.jsx)(ProductMap, {
                  href: (_date$venues9 = date.venues) === null || _date$venues9 === void 0 ? void 0 : (_date$venues9$ = _date$venues9[0]) === null || _date$venues9$ === void 0 ? void 0 : _date$venues9$.link,
                  children: " (Mapa)"
                })]
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ProductQuantity, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Label, {
                children: t('cart.header.count')
              }), !isRealized && !isCustom && date.date.state === Calendar/* EventDateState.AVAILABLE */.$K.AVAILABLE && /*#__PURE__*/(0,jsx_runtime.jsx)(Quantity/* default */.Z, {
                quantity: quantities[date.date._key],
                setPlusQuantity: function setPlusQuantity() {
                  setQuantities(_objectSpread(_objectSpread({}, quantities), {}, (0,defineProperty/* default */.Z)({}, date.date._key, quantities[date.date._key] += 1)));
                },
                setMinusQuantity: function setMinusQuantity() {
                  setQuantities(_objectSpread(_objectSpread({}, quantities), {}, (0,defineProperty/* default */.Z)({}, date.date._key, quantities[date.date._key] -= quantities[date.date._key] > 1 ? 1 : 0)));
                }
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ProductPrice, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Label, {
                children: t('cart.header.priceWithoutVat')
              }), !isRealized && date.date.state === Calendar/* EventDateState.AVAILABLE */.$K.AVAILABLE && /*#__PURE__*/(0,jsx_runtime.jsx)(Value, {
                withHeight: true,
                isPrice: true,
                children: isCustom ? '0 Kč' : "".concat((0,cart_utils/* formatMoneyToCZK */.DM)(Math.round(((_date$modules = date.modules) === null || _date$modules === void 0 ? void 0 : (_date$modules$ = _date$modules[0]) === null || _date$modules$ === void 0 ? void 0 : _date$modules$.price) * quantities[date.date._key] * 100) / 100), " K\u010D")
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ProductPrice, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Label, {
                children: t('cart.header.price')
              }), !isRealized && date.date.state === Calendar/* EventDateState.AVAILABLE */.$K.AVAILABLE && /*#__PURE__*/(0,jsx_runtime.jsx)(Value, {
                withHeight: true,
                isPrice: true,
                children: isCustom ? '0 Kč' : "".concat((0,cart_utils/* formatMoneyToCZK */.DM)(Math.round(((_date$modules2 = date.modules) === null || _date$modules2 === void 0 ? void 0 : (_date$modules2$ = _date$modules2[0]) === null || _date$modules2$ === void 0 ? void 0 : _date$modules2$.price_with_vat) * quantities[date.date._key] * 100) / 100), " K\u010D")
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Buy, {
              children: [!isAcademy && isRunning && /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
                disabled: true,
                text: t('training.status.progress'),
                fullWidth: true
              }), isRealized && !isRunning && /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
                disabled: true,
                text: t('training.status.realized'),
                fullWidth: true
              }), (isAcademy || !isRunning) && !isRealized && !isCustom && /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
                onClick: function onClick() {
                  var _window, _window$fbq, _date$modules3, _date$modules3$;

                  (_window = window) === null || _window === void 0 ? void 0 : (_window$fbq = _window.fbq) === null || _window$fbq === void 0 ? void 0 : _window$fbq.call(_window, 'track', constants/* FBQ_EVENTS.ADD_TO_CART */.PT.ADD_TO_CART);
                  addOrUpdateItemInCart(date === null || date === void 0 ? void 0 : (_date$modules3 = date.modules) === null || _date$modules3 === void 0 ? void 0 : (_date$modules3$ = _date$modules3[0]) === null || _date$modules3$ === void 0 ? void 0 : _date$modules3$._key, quantities[date.date._key]);
                },
                text: date.accessible ? t('training.addToCartAgain.button') : t('training.addToCart.button'),
                fullWidth: true,
                disabled: date.date.state != Calendar/* EventDateState.AVAILABLE */.$K.AVAILABLE
              })]
            })]
          }), (date === null || date === void 0 ? void 0 : (_date$tags2 = date.tags) === null || _date$tags2 === void 0 ? void 0 : (_date$tags2$filter = _date$tags2.filter(function (tag) {
            return tag.label;
          })) === null || _date$tags2$filter === void 0 ? void 0 : _date$tags2$filter.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(Tags, {
            children: date === null || date === void 0 ? void 0 : (_date$tags3 = date.tags) === null || _date$tags3 === void 0 ? void 0 : (_date$tags3$filter = _date$tags3.filter(function (tag) {
              return tag.label;
            })) === null || _date$tags3$filter === void 0 ? void 0 : _date$tags3$filter.map(function (tag, key) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)(Tag/* default */.Z, {
                name: tag.title,
                color: tag.color
              }, key);
            })
          })]
        }, index);
      }), (modules === null || modules === void 0 ? void 0 : modules.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)(TableItem, {
        isCheckout: true,
        isSummary: true,
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(ProductDetail, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(ProductName, {
            isBold: true,
            noWrap: true,
            children: [t('training.subscription.label'), /*#__PURE__*/(0,jsx_runtime.jsx)(ProductPackage, {
              children: modules.map(function (module, key) {
                var subscriptionPackage = constants_packages/* SUBSCRIPTION_PACKAGES.find */.QG.find(function (subPackage) {
                  return subPackage.key === module.module._key;
                });
                return /*#__PURE__*/(0,jsx_runtime.jsx)(Package/* default */.Z, {
                  color: subscriptionPackage.color,
                  symbol: subscriptionPackage.icon
                }, key);
              })
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(ProductPackageTitle, {
            minWidth: 300,
            children: t('training.subscription.title')
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(ProductQuantity, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(ProductPrice, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(ProductPrice, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Label, {
            children: t('cart.header.price')
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Value, {
            withHeight: true,
            isPrice: true,
            children: "0 K\u010D"
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Buy, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
            onClick: function onClick() {
              return router.push({
                pathname: constants/* ROUTES.SUBSCRIPTION */.Z6.SUBSCRIPTION
              });
            },
            text: t('training.showMore.button'),
            fullWidth: true
          })
        })]
      })]
    })
  });
};

/* harmony default export */ var TrainingDates = (TrainingDatesTemplate);

/***/ }),

/***/ 43156:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Quantity_Quantity; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(96502);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 7 modules
var styled_components_browser_esm = __webpack_require__(50661);
;// CONCATENATED MODULE: ./src/ui/Quantity/Quantity.element.tsx


var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Quantityelement__Wrapper",
  componentId: "sc-uhsm71-0"
})(["width:", ";display:flex;justify-content:space-between;align-items:center;border-radius:", ";border:1px solid ", ";"], (0,polished_esm/* rem */.hO)(90), (0,polished_esm/* rem */.hO)(4), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.secondaryGrey;
});
var Minus = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Quantityelement__Minus",
  componentId: "sc-uhsm71-1"
})(["cursor:pointer;font-size:", ";margin-bottom:", ";padding:", " ", ";"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontSizes.h4;
}, (0,polished_esm/* rem */.hO)(4), (0,polished_esm/* rem */.hO)(0), (0,polished_esm/* rem */.hO)(15));
var Quantity = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Quantityelement__Quantity",
  componentId: "sc-uhsm71-2"
})(["font-size:", ";"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.fontSizes.textMedium;
});
var Plus = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Quantityelement__Plus",
  componentId: "sc-uhsm71-3"
})(["cursor:pointer;font-size:", ";margin-bottom:", ";padding:", " ", ";"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.fontSizes.h5;
}, (0,polished_esm/* rem */.hO)(2), (0,polished_esm/* rem */.hO)(0), (0,polished_esm/* rem */.hO)(15));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/ui/Quantity/Quantity.tsx





var QuantityTemplate = function QuantityTemplate(_ref) {
  var quantity = _ref.quantity,
      setPlusQuantity = _ref.setPlusQuantity,
      setMinusQuantity = _ref.setMinusQuantity;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Wrapper, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Minus, {
      onClick: function onClick() {
        return setMinusQuantity();
      },
      children: "-"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Quantity, {
      children: quantity
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Plus, {
      onClick: function onClick() {
        return setPlusQuantity();
      },
      children: "+"
    })]
  });
};

/* harmony default export */ var Quantity_Quantity = (QuantityTemplate);

/***/ }),

/***/ 83297:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ TitleTagTypes; },
  "C": function() { return /* binding */ Title; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(96502);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 7 modules
var styled_components_browser_esm = __webpack_require__(50661);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
;// CONCATENATED MODULE: ./src/ui/SectionTitle/Title.element.tsx



var TitleStyles = (0,styled_components_browser_esm/* css */.iv)(["font-size:", ";line-height:", ";font-weight:", ";font-family:", ";padding:", ";", ";@media (min-width:", "px){", ";padding:", ";font-size:", ";}"], function (_ref) {
  var theme = _ref.theme;
  return theme.fontSizes.h4;
}, (0,polished_esm/* rem */.hO)(40), function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontWeights.textBold;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.fonts.fontSecondary;
}, function (prop) {
  return prop.withoutPadding ? 0 : "".concat((0,polished_esm/* rem */.hO)(20), " 0");
}, function (prop) {
  return prop.isBlack ? "color: ".concat(prop.theme.colors.black) : "color: ".concat(prop.theme.colors.primary);
}, theme/* breakpoints.sm */.A.sm, function (prop) {
  return prop.alignLeft ? 'text-align: left' : 'text-align: center';
}, function (prop) {
  return prop.withoutPadding ? 0 : "".concat((0,polished_esm/* rem */.hO)(20), " 0 ").concat((0,polished_esm/* rem */.hO)(45), " 0");
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.fontSizes.h3;
});
var WrapperDiv = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Titleelement__WrapperDiv",
  componentId: "sc-s8z71i-0"
})(["", ""], TitleStyles);
var WrapperH1 = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
  displayName: "Titleelement__WrapperH1",
  componentId: "sc-s8z71i-1"
})(["", ""], TitleStyles);
var WrapperH2 = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
  displayName: "Titleelement__WrapperH2",
  componentId: "sc-s8z71i-2"
})(["", ""], TitleStyles);
var WrapperH3 = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
  displayName: "Titleelement__WrapperH3",
  componentId: "sc-s8z71i-3"
})(["", ""], TitleStyles);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/ui/SectionTitle/Title.tsx



var TitleTagTypes;

(function (TitleTagTypes) {
  TitleTagTypes["H1"] = "h1";
  TitleTagTypes["H2"] = "h2";
  TitleTagTypes["H3"] = "h3";
})(TitleTagTypes || (TitleTagTypes = {}));

var TitleTemplate = function TitleTemplate(_ref) {
  var children = _ref.children,
      alignLeft = _ref.alignLeft,
      withoutPadding = _ref.withoutPadding,
      isBlack = _ref.isBlack,
      tagType = _ref.tagType;

  if (tagType === TitleTagTypes.H1) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(WrapperH1, {
      withoutPadding: withoutPadding,
      alignLeft: alignLeft,
      isBlack: isBlack,
      children: children
    });
  }

  if (tagType === TitleTagTypes.H3) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(WrapperH3, {
      withoutPadding: withoutPadding,
      alignLeft: alignLeft,
      isBlack: isBlack,
      children: children
    });
  }

  if (tagType === TitleTagTypes.H2) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(WrapperH2, {
      withoutPadding: withoutPadding,
      alignLeft: alignLeft,
      isBlack: isBlack,
      children: children
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(WrapperDiv, {
    withoutPadding: withoutPadding,
    alignLeft: alignLeft,
    isBlack: isBlack,
    children: children
  });
};

/* harmony default export */ var Title = (TitleTemplate);

/***/ })

}]);